// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SwBy","toggleWrap":"styles_toggleWrap__19jT7","content":"styles_content__yBBsd","selectAreaCode":"styles_selectAreaCode__1cmJ9"};